import { render } from "./EamonPlanet.vue?vue&type=template&id=48774cb4"
import script from "./EamonPlanet.vue?vue&type=script&lang=js"
export * from "./EamonPlanet.vue?vue&type=script&lang=js"

import "./EamonPlanet.vue?vue&type=style&index=0&id=48774cb4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__